module.exports = __webpack_public_path__ + "static/img/图层51.504a04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层51.png
// module id = Y1DH
// module chunks = 0